/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteFixedPriceLockInput = {
    projectId?: string | null | undefined;
    fixedPriceLockId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteFixedPriceLockMutationVariables = {
    input: DeleteFixedPriceLockInput;
};
export type deleteFixedPriceLockMutationResponse = {
    readonly deleteFixedPriceLock: {
        readonly deleteFixedPriceLockId: string;
    } | null;
};
export type deleteFixedPriceLockMutation = {
    readonly response: deleteFixedPriceLockMutationResponse;
    readonly variables: deleteFixedPriceLockMutationVariables;
};



/*
mutation deleteFixedPriceLockMutation(
  $input: DeleteFixedPriceLockInput!
) {
  deleteFixedPriceLock(input: $input) {
    deleteFixedPriceLockId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteFixedPriceLockInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFixedPriceLockPayload",
    "kind": "LinkedField",
    "name": "deleteFixedPriceLock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleteFixedPriceLockId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFixedPriceLockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFixedPriceLockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteFixedPriceLockMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFixedPriceLockMutation(\n  $input: DeleteFixedPriceLockInput!\n) {\n  deleteFixedPriceLock(input: $input) {\n    deleteFixedPriceLockId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e227dca46e1752fb5839d8672cf36b92';
export default node;
